import {DOM, globals, platform} from "../variables";

export const setHtmlClasses = () => {
  platform.mobile.iOS ? DOM.html.classList.add('iOS') : null
  platform.mobile.iPadOS ? DOM.html.classList.add('iPadOS') : null
  platform.mobile.android ?  DOM.html.classList.add('android') : null
  globals.hasTouchScreen() ? DOM.html.classList.add('touch') : null
  navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0 ? DOM.html.classList.add('safari') : null
}
